import React, { useState, useEffect } from 'react'

import Prism from 'prismjs'
import PrismCurl from '../../../prism/PrismCurl'

import { PRISM_LANGUAGES } from '~components/TabbedCodeBlocks'
import Generic from './Generic'

import 'prismjs/components/prism-json'
import 'prismjs/components/prism-java'
import 'prismjs/components/prism-csharp'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-swift'
import 'prismjs/components/prism-yaml'
import 'prismjs/components/prism-ini'

import 'prismjs/plugins/line-highlight/prism-line-highlight'
import 'prismjs/plugins/line-numbers/prism-line-numbers.css'

const Component = ({
  language,
  code,
  config = {},
  success
}) => {
  const [expanded, setExpanded] = useState(false)
  const [highlighted, setHighlighted] = useState(false)
  const className = `language-${PRISM_LANGUAGES[language]}`

  useEffect(() => {
    Prism.languages.curl = PrismCurl
    Prism.plugins.LineNumbers = true
    Prism.highlightAll()
    setHighlighted(true)
  }, [])

  return <Generic 
    expanded={expanded}
    setExpanded={setExpanded}
    className={className}
    highlighted={highlighted}
    success={success}
    config={config}
    code={code} />
}

export default Component